import { render, staticRenderFns } from "./MarkSetting.vue?vue&type=template&id=a0293f00&scoped=true"
import script from "./MarkSetting.vue?vue&type=script&lang=js"
export * from "./MarkSetting.vue?vue&type=script&lang=js"
import style0 from "./MarkSetting.vue?vue&type=style&index=0&id=a0293f00&prod&lang=scss&scoped=true"
import style1 from "./MarkSetting.vue?vue&type=style&index=1&id=a0293f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0293f00",
  null
  
)

export default component.exports